import { render, staticRenderFns } from "./EntityFormView.vue?vue&type=template&id=131570cd&scoped=true"
import script from "./EntityFormView.vue?vue&type=script&lang=js"
export * from "./EntityFormView.vue?vue&type=script&lang=js"
import style0 from "./EntityFormView.vue?vue&type=style&index=0&id=131570cd&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131570cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/graphileon/graphileon/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('131570cd')) {
      api.createRecord('131570cd', component.options)
    } else {
      api.reload('131570cd', component.options)
    }
    module.hot.accept("./EntityFormView.vue?vue&type=template&id=131570cd&scoped=true", function () {
      api.rerender('131570cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/entity-form-view/EntityFormView.vue"
export default component.exports